module.exports = __webpack_public_path__ + "img/2-6-what-we-are.539f15f0.jpg";